/**
 * Main Router Configuration
 *
 * Assembles all feature routes into a single router.
 */
import React from 'react';
import { createRouter, createRoute } from '@tanstack/react-router';
import { registerRouter } from '@bb/session-manager';
import { rootRoute, authLayoutRoute } from './rootRoute';
import { publicRoutes } from './publicRoutes';
import { homeRoutes } from './features/homeRoutes';
import { contractRoutes } from './features/contractRoutes';
import { clauseRoutes } from './features/clauseRoutes';
import { modelRoutes } from './features/modelRoutes';
import { adminRoutes } from './features/adminRoutes';
import { reportingRoutes } from './features/reportingRoutes';

// Lazy load NotFound page
const NotFound = React.lazy(() => import('../pages/NotFound/NotFound'));

/**
 * Catch-all not found route (within authenticated area)
 */
const notFoundRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '*',
  component: NotFound,
});

// ============================================
// BUILD ROUTE TREE
// ============================================
const routeTree = rootRoute.addChildren([
  // Public routes (login, logout)
  ...publicRoutes,
  // Authenticated routes under /bbweb
  authLayoutRoute.addChildren([
    ...homeRoutes,
    ...contractRoutes,
    ...clauseRoutes,
    ...modelRoutes,
    ...adminRoutes,
    ...reportingRoutes,
    notFoundRoute,
  ]),
]);

// ============================================
// CREATE ROUTER
// ============================================
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

// Register for auth state invalidation
registerRouter(router);

// Note: TypeScript type registration is not needed for JSX projects
// but would be: declare module '@tanstack/react-router' { interface Register { router: typeof router } }
